var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrocoFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 43,
    viewBox: "0 0 115 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 6C49.7711 6 52.7229 8.56604 53 11L115 0L109 17L106 18L98 20L93 21L100 12L65 23L60 19L18 36L58 32L53 37L80 32L88 30L86 33L84 37L93 34L104 31L102 37L100 43H0L12 27L21 16L28 15V14C28 11.2956 30.9518 9 34 9C36.7711 9 38.4458 10.566 39 13L42 12V11C42 8.2956 43.9518 6 47 6ZM51 12C51 13.8931 48.6627 15 47 15C45.3373 15 44 13.6226 44 12L51 11V12ZM37 14C37 15.8931 35.6627 17 34 17C32.3373 17 30 15.6226 30 14L37 13V14Z",
    fill: "#A8F900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrocoFace);
export default __webpack_public_path__ + "static/media/crocoFace.89888bcecc321f40d77af5bd2447df6c.svg";
export { ForwardRef as ReactComponent };